module.exports = __webpack_public_path__ + "img/chuyencan.c633eef1.png";